import { apiPaths } from '../config/api-paths.js';
import type { ExternalIntegrationStatus } from '@hxr/config/external-integrations';
import { readPclabDistributionReadiness } from './external-integration-readiness.js';
import request from '../utils/request.js';
import { stringifyQuery } from '../utils/query.js';
import type {
  ApiResponse,
  DownloadRecord,
  RequestResult,
  MutablePayload,
  QueryParams,
  SoftwareFileInfo,
  SoftwareFileMap,
} from '../types/domain.js';

export async function getUpdatedFiles(
  params: QueryParams,
): Promise<RequestResult<ApiResponse<SoftwareFileMap>>> {
  return request<ApiResponse<SoftwareFileMap>>(
    `${apiPaths.updatedFiles}?${stringifyQuery(params)}`,
  );
}

export async function getPclabDistributionAvailability(): Promise<
  ExternalIntegrationStatus | undefined
> {
  try {
    const response = await window.fetch('/api/readyz', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    const body = (await response.json()) as {
      readonly status?: unknown;
      readonly integrations?: unknown;
    };
    return readPclabDistributionReadiness(body, response.ok);
  } catch {
    return undefined;
  }
}

export async function getLastestVersion(
  params: QueryParams = {},
): Promise<RequestResult<ApiResponse<Readonly<Record<string, string>>>>> {
  return request<ApiResponse<Readonly<Record<string, string>>>>(
    `${apiPaths.latestVersion}?${stringifyQuery(params)}`,
  );
}

export async function getAllVersions(
  params: QueryParams,
): Promise<RequestResult<ApiResponse<SoftwareFileInfo[]>>> {
  return request<ApiResponse<SoftwareFileInfo[]>>(
    `${apiPaths.allVersions}?${stringifyQuery(params)}`,
  );
}

export async function releaseVersion(
  params: MutablePayload,
): Promise<RequestResult<ApiResponse<unknown>>> {
  return request<ApiResponse<unknown>>(apiPaths.releaseVersion, {
    method: 'POST',
    body: params,
  });
}

export async function addDownloadRecord(
  params: MutablePayload,
): Promise<RequestResult<ApiResponse<DownloadRecord>>> {
  return request<ApiResponse<DownloadRecord>>(apiPaths.addDownloadRecord, {
    method: 'POST',
    body: params,
  });
}
